 

import { getToken, setToken, removeToken } from '@/utils/auth'
import { createShop,listDataShop,updateShop } from '@/zsm-api-new/shop.js'
const state = {
  
}

const mutations = {
  
}

const actions = {
  // 创建店铺
  createShop({ commit }, info) {
    return new Promise((resolve, reject) => {
      createShop(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取店铺列表
  listDataShop({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataShop(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // 获取店铺列表
  updateShop({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateShop(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
